"use client";

import type { FC, Ref } from "react";
import { useTranslation } from "react-i18next";
import { AnalysisHeading } from "@huub-web/shared";

import type { AnalysisHeadingTemplateProps } from "../AnalysisHeadingTemplate";

export interface ViewingTipsHeadingTemplateProps
  extends AnalysisHeadingTemplateProps {}

/**
 * @deprecated
 */
export const ViewingTipsHeadingTemplate: FC<
  ViewingTipsHeadingTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ generatedAt, title, description, ref }) => {
  const { t } = useTranslation();

  return (
    <AnalysisHeading
      ref={ref}
      generatedAt={generatedAt}
      title={title ?? t("viewingTipsHeading.title")}
      description={description ?? t("viewingTipsHeading.description")}
    />
  );
};
